import {
  CLIENT_ID,
  ACCESS_TOKEN,
  PROFILE_IMG,
  PERMISSIONS,
  GLOBAL_CURRENCY
} from "../action";

const initialState = {
  accessToken: null,
  clientId: null,
  profileImg: null,
  permissions: null,
  global_currency: null
};

const stroreReducer = (state = initialState, action: any) => {
  if (action.type === ACCESS_TOKEN) {
    return {
      ...state,
      accessToken: action.payload,
    };
  } else if (action.type === CLIENT_ID) {
    return {
      ...state,
      clientId: action.payload,
    };
  } else if (action.type === PROFILE_IMG) {
    console.log("action", action);
    return {
      ...state,
      profileImg: action.payload
    }
  } else if (action.type === PERMISSIONS) {
    return {
      ...state,
      permissions: action.payload
    }
  } else if (action.type === GLOBAL_CURRENCY) {
    return {
      ...state,
      global_currency: action.payload
    }
  }
  return { ...state }
};

export default stroreReducer;
